import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { gmToolNewCom, gmToolNewPage } from "@/mixins/index";
import uploadImagetow from '@/components/uploadImagetow';
import { szgmdoSend } from '@/api/gmToolNew/gmToolNew';
export default {
  components: {
    uploadImagetow: uploadImagetow
  },
  mixins: [gmToolNewCom, gmToolNewPage],
  data: function data() {
    var _this = this;

    var validateuids = function validateuids(rule, value, callback) {
      var regex = /[\u4e00-\u9fa5，]/;

      if (regex.test(value) || !value) {
        callback(new Error(_this.$t('roleIdIncorrect')));
      } else {
        callback();
      }
    };

    return {
      paramsData: {
        uids: '',
        type: 'to_users',
        id: '',
        server_id: [],
        expire: '',
        start_time: '',
        end_time: '',
        serverData: []
      },
      expires: [],
      dialogShow: false,
      emailType: [{
        label: this.$t('allPlayers'),
        value: 'all'
      }, {
        label: this.$t('selectedPlayers'),
        value: 'to_users'
      }, {
        label: this.$t('normalAnnouncement'),
        value: 'compensate'
      }],
      rules: {
        uids: [{
          required: true,
          validator: validateuids,
          trigger: "blur"
        }],
        type: [{
          required: true,
          message: this.$t('pleaseSelectType'),
          trigger: "blur"
        }],
        server_id: [{
          required: true,
          message: this.$t('pleaseSelectServer'),
          trigger: "blur"
        }],
        expire: [{
          required: true,
          message: this.$t('pleaseSelectExpireTime'),
          trigger: "blur"
        }],
        expires: [{
          required: true,
          message: this.$t('pleaseSelectTime'),
          trigger: "blur"
        }]
      },
      isPermissions: false,
      checked: false
    };
  },
  created: function created() {},
  methods: {
    open: function open(data, serverChannel) {
      var isPermissions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.paramsData.id = data.id;
      var nowD = (new Date(this.$times.zeroTimeZone()).getTime() + 3600 * 1000 * 24 * 7) / 1000;
      this.paramsData.expire = this.$times.timestampToTime(nowD, 'YY-MM-DD HH:II:SS');
      this.paramsData.start_time = this.$times.timestampToTime(nowD, 'YY-MM-DD');
      this.paramsData.end_time = this.$times.timestampToTime(nowD, 'YY-MM-DD');
      this.expires = [this.$times.timestampToTime(nowD, 'YY-MM-DD'), this.$times.timestampToTime(nowD, 'YY-MM-DD')];
      this.dialogShow = true;
      this.checked = false;

      if (isPermissions) {
        this.isPermissions = isPermissions;
        this.paramsData.type = this.emailType[1].value;
      }

      this.serverChannel = serverChannel;
      var send_txt = data.send_txt && JSON.parse(data.send_txt);

      if (send_txt) {
        this.server_channel = send_txt.server_channel;
        this.show_test = send_txt.is_test_server;
        this.serverChannelChange();
        this.paramsData.server_id = send_txt.server_id.split(",").map(Number);
        this.serverIdChange(this.paramsData.server_id, send_txt.uids);
        this.paramsData.type = send_txt.type;
        this.expires = [send_txt.start_time, send_txt.end_time];
        this.paramsData.start_time = send_txt.start_time;
        this.paramsData.end_time = send_txt.end_time;
      }
    },
    selectAll: function selectAll() {
      var _this2 = this;

      this.paramsData.server_id = [];
      this.paramsData.serverData = [];

      if (this.checked) {
        this.serverListYJ.map(function (item) {
          _this2.paramsData.server_id.push(item.serverID);

          _this2.paramsData.serverData.push({
            label: item.serverID,
            value: ''
          });
        });
      } else {
        this.paramsData.server_id = [];
        this.paramsData.serverData = [];
      }
    },
    serverIdChange: function serverIdChange(e, uids) {
      var _this3 = this;

      var uidData = uids ? JSON.parse(uids) : '';
      this.paramsData.serverData = [];
      e.forEach(function (i) {
        _this3.paramsData.serverData.push({
          label: i,
          value: uidData && uidData[i].length ? uidData[i].join(",") : ''
        });
      });

      if (e.length === this.serverListYJ.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    searchTimeChange: function searchTimeChange(e) {
      this.paramsData.start_time = e[0];
      this.paramsData.end_time = e[1];
    },
    fileUp: function fileUp(e, index) {
      this.paramsData.serverData[index].value = e.data.toString();
    },
    clearData: function clearData(isClearId) {
      this.paramsData = {
        uids: '',
        type: 'to_users',
        server_id: '',
        serverData: [],
        id: isClearId ? '' : this.paramsData.id,
        expire: this.$times.timestampToTime((new Date(this.$times.zeroTimeZone()).getTime() + 3600 * 1000 * 24 * 7) / 1000, 'YY-MM-DD HH:II:SS')
      };
      this.server_channel = '';
      this.show_test = '';
      this.serverListYJ = [];
      this.$refs.ruleForm.clearValidate();
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this4 = this;

      this.$refs.ruleForm.clearValidate();
      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this4.$confirm(_this4.$t('confirmSendEmail'), _this4.$t('tip'), {
            confirmButtonText: _this4.$t('confirm'),
            cancelButtonText: _this4.$t('cancel'),
            type: 'warning',
            beforeClose: function beforeClose(action, instance, done) {
              if (action === 'confirm') {
                instance.confirmButtonLoading = true;
                var data = JSON.parse(JSON.stringify(_this4.paramsData));
                var uids = data.uids.split(',');
                data.server_id = data.server_id.toString();

                if (data.type == 'to_users') {
                  if (data.serverData.length > 1) {
                    var d = {};

                    _this4.paramsData.serverData.forEach(function (i) {
                      var uidI = i.value.split(',');
                      uidI = uidI.map(function (i) {
                        return i = parseInt(i);
                      });
                      d[i.label] = uidI;
                    });

                    data.uids = JSON.stringify(d);
                  } else {
                    var uidI = _this4.paramsData.serverData[0].value.split(',');

                    uidI = uidI.map(function (i) {
                      return i = parseInt(i);
                    });
                    data.uids = JSON.stringify(uidI);
                  }
                } else {
                  uids = uids.map(function (i) {
                    return i = parseInt(i);
                  });
                  data.uids = data.uids ? JSON.stringify(uids) : '';
                }

                data.server_channel = _this4.server_channel;
                data.is_test_server = _this4.show_test;
                szgmdoSend(_objectSpread(_objectSpread({}, data), {}, {
                  env_id: _this4.propsData.env_id,
                  game_id: _this4.rawData.game_id
                })).then(function (res) {
                  if (res.code == 200) {
                    _this4.$message({
                      type: "success",
                      message: _this4.$t('operationSuccess')
                    });

                    _this4.dialogShow = false;
                    done();
                    instance.confirmButtonLoading = false;

                    _this4.$emit('change');
                  } else {
                    done();
                    instance.confirmButtonLoading = false;
                  }
                });
              } else {
                done();
              }
            }
          });
        }
      });
    }
  }
};